export class AnimatedCreativeAdApi {
    constructor(_animator, _renderer) {
        this._animator = _animator;
        this._renderer = _renderer;
        console.debug('[AdApi] constructed');
    }
    play() {
        this._animator.play();
    }
    pause() {
        this._animator.pause();
    }
    stop() {
        this._animator.stop();
    }
    seek(time) {
        this._animator.seek(time);
    }
    mute(muted) {
        this._renderer.mute_m(muted);
    }
}
